import 'slick-carousel';
import $ from 'jquery';

const setup = (selector: string | JQuery<HTMLElement>, options: object) => {
  if (typeof selector === 'string') {
    selector = $(selector);
  }

  selector.slick(options);
}

export default {
  setup,
};
